<script lang="ts">
    import {onMount} from "svelte";
    import "../../../node_modules/maplibre-gl/dist/maplibre-gl.css";
    import {get, Writable, writable} from "svelte/store";
    import {MapTilerBasicLayer} from "../../map/layers/MapTilerBasicLayer";
    import {SharedScenarioManager} from "./SharedScenarioManager";
    import Head from "../../header/Head.svelte";
    import { LightGreyMapLayer } from "../../map/layers/LightGreyMapLayer";
    import type { BaseLayer } from "../../lib/maplibre/baselayers/BaseLayer";

    // define exports
    export let id: string;

    // define variables.
    let mapContainer: HTMLDivElement;
    let manager = new SharedScenarioManager(id);
    const activeBaseLayer: Writable<{ id: string; layer: BaseLayer }> =
        writable({
            id: "light",
            layer: new LightGreyMapLayer(),
        });

    onMount(async () => {
        await manager.initialize(mapContainer, get(activeBaseLayer).layer);
    });
</script>

<svelte:head>
    <title>ANYWAYS</title>
</svelte:head>

<Head />

<div class="map h-100 w-100" bind:this={mapContainer}>
    <!-- No other content or controls on the map for now -->
</div>